'use client';

export { OfferWidgetComponent as OfferWidgetComponentB } from './OfferWidgetComponent';
